import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName',
  standalone: false
})
export class FileNamePipe implements PipeTransform {
  transform(path?: string): string {
    return (path || '').split('/').pop() || '';
  }
}
